import React from "react";
import {Navigate} from 'react-router-dom'

export const PrivateRoute = ({ component: RouteComponent }) => {
    const isAuthenticated = localStorage.getItem('TOKEN');

    return isAuthenticated ? RouteComponent : <Navigate to="/" />
}
